import type { ViewEndpoint } from "../protocol/events";
import { Framer, videoStyle, type Sensor } from "./framing";
import type { ViewControl } from "./view-control";
import { mountFindConfirmation } from "./find-confirmation";

export function mountPreview(
  endpoint: ViewEndpoint,
  control: ViewControl,
  camera: HTMLElement,
  video: HTMLVideoElement,
) {
  const framer = new Framer(endpoint, control);
  const clearConfirmation = mountFindConfirmation(endpoint, camera);
  let sensor: Sensor | null = null;

  // Native video needs layout updates only; the confirmation paints once per find.
  const reframe = (): void => {
    clearConfirmation();
    const shown = framer.frame(sensor, camera.clientWidth, camera.clientHeight);
    if (shown && sensor)
      Object.assign(
        video.style,
        videoStyle(shown, sensor, camera.clientWidth, camera.clientHeight),
      );
  };
  return {
    reframe,
    start: (next: Sensor) => {
      sensor = next;
      reframe();
    },
    resizeSensor: (next: Sensor) => {
      sensor = next;
      reframe();
    },
    stop: () => {
      clearConfirmation();
      sensor = null;
      framer.reset();
      video.style.transform = "";
      video.style.width = "";
      video.style.height = "";
    },
  };
}
